import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface VoidFileResponse {
  documentReference: fhirTypes.DocumentReference;
}

export const useVoidFile = (
  patientId: string,
  documentReferenceId?: string,
) => {
  const queryClient = useQueryClient();

  return useApiMutation<VoidFileResponse, void>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.Files.UPDATE(
        patientId,
        documentReferenceId,
      ),
      mutationFn: () => {
        return axiosInstance.patch(
          `/charting/files/document-reference/${documentReferenceId}/void`,
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Files.DEFAULT(patientId),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Files.DEFAULT({ patientId }),
        });
      },
    },
  });
};
